<template>
  <div id="post-filter-promocode-input">
    <label class="form-label">Промокод</label>
    <div class="row g-2">
      <div class="col">
        <div class="input-icon">
          <input @keyup.enter="onChange" type="text" class="form-control" placeholder="Введите промокод..." v-model="fields.promocode">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./css/style.css"
import {defineComponent, watch, onMounted, reactive} from "vue"

export default defineComponent({
  name: "Promocode",
  components: {},
  props: {
    data: {
      type: [Object, null],
      default: null,
    },
  },
  setup(props, {emit}) {
    const fields = reactive({
      promocode: props.data.val,
    })

    onMounted(async () => {
      fields.promocode = props.data.val
    })

    watch(() => props.data.val, (val) => {
      fields.promocode = val
    })

    function onChange(value) {
      fields.promocode = value.target.value
      emit("onChange", fields.promocode)
    }

    return {
      onChange,
      fields,
    }
  }
})
</script>
